function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(255,255,255,0.47);opacity:0;}.b{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-51 -15.636)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 18.7,
  height: 18.7,
  transform: "translate(51 15.636)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M21.719,10.213H19.064a.791.791,0,0,1-.585-.263C17.1,8.4,16.575,7.875,16.01,7.875H11.846c-.57,0-1.13.526-2.518,2.08a.775.775,0,0,1-.58.258h-.2v-.39a.391.391,0,0,0-.39-.39H6.892a.391.391,0,0,0-.39.39v.39H6.137a1.58,1.58,0,0,0-1.637,1.5v8.573A1.686,1.686,0,0,0,6.132,21.9H21.719A1.561,1.561,0,0,0,23.2,20.282V11.708A1.452,1.452,0,0,0,21.719,10.213ZM16.4,19.005a.585.585,0,0,1-.234.3,4.062,4.062,0,0,1-2.314.721,4.109,4.109,0,0,1-2.781-1.106,4.2,4.2,0,0,1-1.315-2.445H8.762a.281.281,0,0,1-.273-.321.175.175,0,0,1,.034-.088L10.058,14a.268.268,0,0,1,.429,0l1.568,2.036a.28.28,0,0,1-.088.414.156.156,0,0,1-.093.024H10.862a3.115,3.115,0,0,0,.969,1.656,2.92,2.92,0,0,0,3.726.239.569.569,0,0,1,.317-.1.532.532,0,0,1,.4.18A.539.539,0,0,1,16.4,19.005Zm2.757-3.288-1.52,2.09a.272.272,0,0,1-.4.039.129.129,0,0,1-.024-.029l-1.578-2.1a.28.28,0,0,1,.093-.414.2.2,0,0,1,.093-.024h1.023a3.238,3.238,0,0,0-.969-1.734,2.924,2.924,0,0,0-3.726-.258.549.549,0,0,1-.312.1.542.542,0,0,1-.4-.175.558.558,0,0,1,.107-.852,4.078,4.078,0,0,1,2.319-.721,4.13,4.13,0,0,1,2.815,1.086,4.469,4.469,0,0,1,1.276,2.552h1.028a.182.182,0,0,1,.088.024A.294.294,0,0,1,19.157,15.717Z",
  transform: "translate(46.5 10.096)"
}));

function SvgChangeCam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.705,
    height: 18.7,
    viewBox: "0 0 18.705 18.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeCam);
export default __webpack_public_path__ + "static/media/change_cam.e6ca3f36.svg";
export { ForwardRef as ReactComponent };